import { useState } from 'react';

const fmtARS = n => Math.round(Number(n)).toLocaleString('es-AR');

const BG_FAMILIA = {
  masculino: 'linear-gradient(160deg, #e8ddd0 0%, #c9b898 100%)',
  femenino:  'linear-gradient(160deg, #ede0d4 0%, #d4b8a0 100%)',
  unisex:    'linear-gradient(160deg, #e2ddd4 0%, #c4b898 100%)',
};

const getBg = familia => {
  if (!familia) return BG_FAMILIA.unisex;
  const f = familia.toLowerCase();
  if (f.includes('masc') || f.includes('hombre') || f === 'm') return BG_FAMILIA.masculino;
  if (f.includes('fem') || f.includes('mujer') || f === 'f')  return BG_FAMILIA.femenino;
  return BG_FAMILIA.unisex;
};

export default function PerfumeCard({ perfume, onVerDetalle, onAgregarCarrito }) {
  const [hover, setHover] = useState(false);
  const [added, setAdded] = useState(false);

  const precioNum   = parseFloat(perfume.precio) || 0;
  const precioFinal = perfume.descuento > 0
    ? Math.round(precioNum * (1 - perfume.descuento / 100))
    : precioNum;

  const tieneDecant = parseFloat(perfume.precio_decant_5ml) > 0 || parseFloat(perfume.precio_decant_10ml) > 0;
  const precioDecantMin = Math.min(
    parseFloat(perfume.precio_decant_5ml) || Infinity,
    parseFloat(perfume.precio_decant_10ml) || Infinity
  );
  const sinStock = !perfume.stock || perfume.stock <= 0;

  const handleAgregar = e => {
    e.stopPropagation();
    if (sinStock && !tieneDecant) return;
    if (sinStock && tieneDecant) { onVerDetalle?.(perfume); return; }
    onAgregarCarrito?.(perfume);
    setAdded(true);
    setTimeout(() => setAdded(false), 1400);
  };

  return (
    <div
      onClick={() => onVerDetalle?.(perfume)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: '#fff',
        borderRadius: 8,
        overflow: 'hidden',
        cursor: 'pointer',
        border: `1px solid ${hover ? '#c9a96e' : '#e8e4de'}`,
        boxShadow: hover ? '0 16px 48px rgba(0,0,0,0.10)' : '0 2px 8px rgba(0,0,0,0.04)',
        transform: hover ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'all 0.32s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        position: 'relative',
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      }}
    >
      {/* IMAGE */}
      <div style={{
        position: 'relative',
        paddingTop: '115%',
        background: getBg(perfume.familia),
        overflow: 'hidden',
      }}>
        <img
          src={perfume.imagen_url}
          alt={perfume.nombre}
          style={{
            position: 'absolute',
            top: 8, left: 8,
            width: 'calc(100% - 16px)',
            height: 'calc(100% - 16px)',
            objectFit: 'contain',
            transform: hover ? 'scale(1.04)' : 'scale(1)',
            transition: 'transform 0.5s ease',
          }}
        />

        {/* BADGE DESCUENTO */}
        {perfume.descuento > 0 && (
          <div style={{
            position: 'absolute', top: 10, left: 10,
            background: '#111', color: '#fff',
            fontSize: 9, fontWeight: 700,
            padding: '4px 10px', borderRadius: 20,
            letterSpacing: 1, textTransform: 'uppercase',
            fontFamily: "'DM Sans', sans-serif",
          }}>
            −{perfume.descuento}%
          </div>
        )}

        {/* BADGE DECANT */}
        {tieneDecant && (
          <div style={{
            position: 'absolute', top: 10, right: 10,
            background: 'rgba(201,169,110,0.92)', color: '#fff',
            fontSize: 9, fontWeight: 700,
            padding: '4px 10px', borderRadius: 20,
            letterSpacing: 0.5,
            fontFamily: "'DM Sans', sans-serif",
          }}>
            🧪 Decant
          </div>
        )}

        {/* SIN STOCK OVERLAY */}
        {sinStock && (
          <div style={{
            position: 'absolute', inset: 0,
            background: tieneDecant ? 'rgba(244,239,230,0.12)' : 'rgba(255,255,255,0.65)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {!tieneDecant && (
              <span style={{
                fontSize: 9, fontWeight: 600, letterSpacing: 2.5,
                textTransform: 'uppercase', color: '#999',
                background: 'rgba(255,255,255,0.92)', padding: '5px 14px',
                borderRadius: 20, fontFamily: "'DM Sans', sans-serif",
              }}>Sin stock</span>
            )}
          </div>
        )}
      </div>

      {/* INFO */}
      <div style={{ padding: '14px 14px 16px' }}>
        <div style={{
          fontSize: 9, fontWeight: 600, color: '#c9a96e',
          textTransform: 'uppercase', letterSpacing: 2.5, marginBottom: 4,
        }}>
          {perfume.marca}
        </div>

        <div style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: 17, fontWeight: 600, color: '#1a1a1a',
          lineHeight: 1.25, marginBottom: 10, letterSpacing: 0.2,
        }}>
          {perfume.nombre}
        </div>

        <div style={{ height: 1, background: 'rgba(26,26,26,0.07)', marginBottom: 10 }} />

        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
          <div>
            <div style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: 20, fontWeight: 700,
              color: sinStock && !tieneDecant ? '#ccc' : '#1a1a1a',
              lineHeight: 1,
            }}>
              {sinStock && tieneDecant
                ? `desde $${fmtARS(precioDecantMin)}`
                : precioNum > 0 ? `$${fmtARS(precioFinal)}` : '—'}
            </div>
            {perfume.descuento > 0 && !sinStock && (
              <div style={{ fontSize: 11, color: '#bbb', textDecoration: 'line-through', marginTop: 2 }}>
                ${fmtARS(precioNum)}
              </div>
            )}
          </div>

          {/* BOTÓN REDONDO + */}
          {onAgregarCarrito && (
            <button
              onClick={handleAgregar}
              disabled={sinStock && !tieneDecant}
              title={sinStock && tieneDecant ? 'Ver decant' : 'Agregar al carrito'}
              style={{
                width: 36, height: 36,
                borderRadius: '50%',
                border: 'none',
                background: added
                  ? '#22a06b'
                  : sinStock
                    ? (tieneDecant ? '#c9a96e' : '#e0e0e0')
                    : '#1a1a1a',
                color: sinStock && !tieneDecant ? '#aaa' : '#fff',
                fontSize: added ? 15 : 20,
                lineHeight: 1,
                cursor: sinStock && !tieneDecant ? 'not-allowed' : 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'background 0.25s, transform 0.15s',
                transform: added ? 'scale(1.18)' : 'scale(1)',
                boxShadow: sinStock && !tieneDecant ? 'none' : '0 2px 8px rgba(0,0,0,0.15)',
                flexShrink: 0,
              }}
            >
              {added ? '✓' : sinStock && tieneDecant ? '🧪' : '+'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
